/**
 * Backend sentinel for "no value" rows in a lookup list (first used by
 * the claimsManagerCptInsurances lookup for payer-less claim lines).
 * It travels through the filter as-is — `q=insurance:__unknown__`,
 * inside a comma list or negated — and only the LABEL is localised.
 */
export const UNKNOWN_LOOKUP_VALUE = '__unknown__';

const _getPreFilterKeys = ({ scit, slit, formulas, tables }) => {
  return {
    [UNKNOWN_LOOKUP_VALUE]: tables.unknownValue || 'Unknown',

    // orders => order type
    fiftyDosePerUnitBuildUp: scit.buildUp50,
    tenDosePerUnitStageOne: scit.stage1,
    tenDosePerUnitStageTwo: scit.stage2,
    tenDosePerUnitStageThree: scit.stage3,
    tenDosePerUnitStageFour: scit.stage4,
    twelveDosePerUnitSCITMaintenance: scit.scitMaintenance,

    oneMonthLowDose: slit.oneMonthLowDose,
    oneMonthSLITMaintenance: slit.oneMonthSLITMaintenance,

    // orders => order formula
    outdoor: formulas.outdoor,
    indoorAllergenMixtureTwo: formulas.indoor2,
    indoorAllergenMixtureThree: formulas.indoor3,
    indoorAllergenMixtureFour: formulas.indoor4,
    mold: formulas.mold,
    environmentMixture: formulas.environment,

    // orders => order status
    sending: tables.sending,
    pending: tables.pending,
    processing: tables.processing,
    shipped: tables.shipped,
    onHold: tables.onHold,
    delayed: tables.delayed,
    canceled: tables.canceled,
    compounding: tables.compounding,

    // assessment => created by. Four values, matching the API's
    // CreationMethod enum — `instant` was missing here and rendered as
    // the raw lowercase string in the filter list.
    manuallyCreated: tables.manuallyCreated,
    integration: tables.integration,
    automated: tables.automated,
    instant: tables.instant,
  };
};

export const getTitle = (options, translation) => {
  const keys = _getPreFilterKeys(translation);
  let resultTitle = '';

  options.forEach(item => {
    if (keys.hasOwnProperty(item)) {
      resultTitle += keys[item] + ', ';
    } else {
      if (item.includes(',')) {
        const splitedItem = item.split(',');
        splitedItem.forEach(item => {
          if (keys.hasOwnProperty(item)) {
            resultTitle += keys[item] + ', ';
          } else {
            resultTitle += item + ',';
          }
        });
        resultTitle += ' ';
      } else {
        resultTitle += item + ', ';
      }
    }
  });

  resultTitle = resultTitle.slice(0, -2);
  return resultTitle;
};
